import { Component, OnInit } from '@angular/core'; // Added OnInit
import { NavigationStart, Router, RoutesRecognized } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';
import { SessionService } from 'src/app/shared/services/session.service'; // Import SessionService

@Component({
  selector: 'app-preferences',
  templateUrl: './preferences.component.html',
  styleUrls: ['./preferences.component.scss']
})
export class PreferencesComponent implements OnInit { // Implements OnInit

  // Sidebar settings
  myAccountActive: boolean = false;
  contactUsActive: boolean = false;
  preferencesActive: boolean = false;
  managePaymentActive: boolean = false;
  autoRedeemActive: boolean = false;
  autoPayActive: boolean = false; // New property for PPI's auto-pay page

  isPPI: boolean = false; // New property to store the session type
  isBilliant:boolean=false;
  constructor(private router: Router, private sessionService: SessionService) { // Inject SessionService
    // Initial check of the URL on component creation
    this.isPPI = this.sessionService.isPPI();

    this.setActiveLinks(this.router.url);

    // Subscribe to router events to update the active state on navigation
    this.router.events.pipe(filter((event: any) => event instanceof NavigationStart)).subscribe(
      (event: NavigationStart) => {
        this.setActiveLinks(event.url);
      }
    );
  }
  
  ngOnInit(): void {
    // We need to re-check the PPI state, as the router events might happen
    // before the session is fully validated.
    this.isPPI = this.sessionService.isPPI();
    // Re-evaluate active links in case session state changes after initial load
    this.setActiveLinks(this.router.url);
    this.isBilliant= sessionStorage.getItem("isBilliant")!=null?sessionStorage.getItem("isBilliant").toLocaleLowerCase()=="true"?true:false:false;
  }

  // Consolidated logic for setting active links
  private setActiveLinks(url: string): void {
    this.myAccountActive = url.startsWith('/my-account');
    this.contactUsActive = url.startsWith('/contact-us');
    this.preferencesActive = url.startsWith('/preferences');

    // Reset all preferences sub-items
    this.managePaymentActive = false;
    this.autoRedeemActive = false;
    this.autoPayActive = false;

    if (this.preferencesActive) {
      if (url.startsWith('/preferences/manage-payment')) {
        this.managePaymentActive = true;
      } else if (url.startsWith('/preferences/auto-redeem')) {
        this.autoRedeemActive = true;
      } else if (url.startsWith('/preferences/auto-pay')) { // New check for auto-pay page
        this.autoPayActive = true;
      }
    }
  }
}
